export const INTEGER_NUMBER_FORMAT = /^\d+$/;
export const DECIMAL_NUMBER_FORMAT = /^\d+([,.]\d{1,})?$/;

/**Monto de plazo fijo: límite de 2 digitos luego de la coma */
export const LIMIT_DECIMALS_FORMAT = /^\d+([,.]\d{1,2})?$/;

/* Restricciones de los campos de los formularios. */
export const EMAIL_MAX_LENGTH = 50;

export const EMAIL_PATTERN: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const EMAIL_PLACEHOLDER = 'Correo (ej: ejemplo@correo.org.ar)';
export const EMAIL_LABEL = 'Ingresá tu correo';

/* Mensajes de error de validación de campo de formulario */
export const INPUT_INVALID_FORMAT_MESSAGE = 'Formato inválido';

/** Otp */
export const OTP_LENGTH = 6;

export const OTP_LABEL = 'Ingresá el código enviado a tu correo';

export const DNI_MIN_LENGTH = 7;
export const DNI_MAX_LENGTH = 8;
export const DNI_PROCEDURE_LENGTH = 11;
export const DNI_PROCEDURE_LENGTH_MESSAGE = `Debe tener ${DNI_PROCEDURE_LENGTH} dígitos`;

export const ADDRESS_MIN_LENGTH = 2;
export const ADDRESS_MAX_LENGTH = 200;

export const TELEPHONE_MIN_LENGTH = 6;
export const TELEPHONE_MAX_LENGTH = 14;

export const CBU_LENGTH = 22;
export const CBU_LENGTH_MESSAGE = `Debe tener ${CBU_LENGTH} dígitos`;

export const CBU_ALIAS_MIN_LENGTH = 6;
export const CBU_ALIAS_MAX_LENGTH = 20;
export const CBU_ALIAS_PATTERN = /^[a-zA-Z0-9.-]+$/;

export const CBU_INVALID_PATTERN_MESSAGE = 'CBU inválido';
/**Patrón de CBU que restringe CBU del mismo banco.*/
export const CBU_PATTERN_OTHER_BANKS = /^(?!014)\d+$/;
export const CBU_PATTERN_OTHER_BANKS_MESSAGE = 'Sólo está permitido ingresar CBU de cuentas de otro Banco';
/**Patrón de CBU que restringe CVU.*/
export const CBU_CVU_PATTERN = /^(?!000)\d+$/;
export const CBU_CVU_PATTERN_MESSAGE = 'No se admiten CVUs';

export const FIXED_TERM_AMOUNT_MIN = 1000;
export const FIXED_TERM_TIME_MIN = 30;
export const FIXED_TERM_TIME_MAX = 540;

export const AMOUNT_LIMIT_DECIMALS_MESSAGE = 'Debe tener hasta 2 dígitos luego de la coma';
